export default "/WebApp/dist/assets/svg/glyphicons-halflings-regular.svg";